import React, { useState, useEffect } from 'react';
import { Box, Grid, GridItem, Text, Button, VStack, Icon } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaFileUpload } from 'react-icons/fa';
import JobCard from './jobCard';
import axios from 'axios';
import { useJobListRefreshContext } from '../../utils/context/JobListRefresh';

const JobList = () => {
  const { jobListRefresh } = useJobListRefreshContext();
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchJobSuggestions = async () => {
      const ticketToken = sessionStorage.getItem('ticketToken');
      if (!ticketToken) {
        console.error('No ticket token found in sessionStorage');
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/applicant/get-job-suggestions`,
          {
            headers: {
              Authorization: `Bearer ${ticketToken}`
            }
          }
        );

        setJobs(response.data.data);
      } catch (error) {
        console.error('Error fetching profile data:', error);
        setJobs([]);
      }
    };

    fetchJobSuggestions();
  }, [jobListRefresh]);

  const handleUploadClick = () => {
    navigate('/seeker-home', { 
      state: { 
        view: 'profile',
        subview: 'documents'
      }
    });
  };

  if (jobs.length === 0) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minH="300px"
        bg="white"
        p={6}
        borderRadius="lg"
        textAlign="center"
      >
        <Icon 
          as={FaFileUpload} 
          w={8} 
          h={8} 
          color="blue.500" 
          mb={4}
        />
        <Text 
          fontSize="lg" 
          fontWeight="semibold" 
          color="gray.700"
          mb={2}
        >
          No Job Suggestions Available
        </Text>
        <Text 
          fontSize="sm" 
          color="gray.500" 
          mb={4}
        >
          Upload your certificates to get matched with jobs
        </Text>
        {/* <Button
          leftIcon={<FaFileUpload />}
          colorScheme="blue"
          borderRadius="50px"
          px={8}
          py={6}
          fontSize="md"
                    onClick={handleUploadClick}
        >
          Upload Documents
        </Button> */}
      </Box>
    );
  }

  return (
    <Box p={4}>
      <Grid
        templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }}
        gap={6}
      >
        {jobs.map((job, index) => (
          <GridItem key={index}>
            <JobCard 
              {...job}
              isApplied={job.isApplied}
              isSaved={job.isSaved}
              category="All"
            />
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
};

export default JobList;